import * as React from 'react'
import useFoundHoursOverviewTable from '../../hooks/tables/useFoundHoursOverviewTable'
import DataGrid from '../shared/DataGrid'
import { FoundHourShape } from '../../api/api_data_types'

interface FoundHoursOverviewProps {
  foundHours: FoundHourShape[]
}

export default function FoundHoursOverview({ foundHours }: FoundHoursOverviewProps) {
  const { table } = useFoundHoursOverviewTable(foundHours)

  return (
    <div>
      <DataGrid table={table} />
    </div>
  )
}